var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-viewer"},[_c('iframe',{staticStyle:{"border":"none","width":"80%","height":"80%"},attrs:{"src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }